import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { QrCodePipe } from '../../../pipes';

@Component({
    selector: 'ecm-mat-seo-qr-code',
    templateUrl: 'material-seo-qr-code.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [AsyncPipe, QrCodePipe, TranslateModule],
})
export class MaterialSeoQrCodeComponent {
    public i18nPath = 'material.seo.qrCode';
    public logoPath = '/assets/images/logo-orange-et-moi-france.png';

    @Input({ required: true }) public url: string;
    @Input() public canInstallNativeApp: boolean;
    @Input() public e2e = 'e2e-mat-seo-qr-code';
}
